import React, { useEffect } from "react";
import Swal from "sweetalert2";

const SessionTimeoutRedirect = () => {
  useEffect(() => {
    Swal.fire({
      title: "Timeout",
      text: "Your Session has been expired please relogin",
      icon: "info",
      confirmButtonText: "Ok",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "https://accredian.com";
      }
    });
  }, []);

  return null;
};

export default SessionTimeoutRedirect;
